import EfScrollAni from '@/efscrollani';
import { useLang } from '@/i18n';
import ScrollMagicFn from '@/utils/ScrollMagic';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import QuoteWinFloat from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinFloat';
import AMZMemberDay from 'elem/compCommon/PillarPageActivities/AMZMemberDay';
import { TimelineMax, TweenMax } from 'gsap';
import { useEffect, useState } from 'react';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import A from './A';
import Choose from './Choose';
import EcoflowUsers from './EcoflowUsers';
import EndorsedBy from './EndorsedBy';
import EnergyStorage from './EnergyStorage';
import Explore from './Explore';
import F from './F';
import Flexible from './Flexible';
import ForBackup from './ForBackup';
import G1 from './G1';
import styles from './index.module.scss';
import JoinCommunity from './JoinCommunity';
import OnePicture from './OnePicture';
import PowerDistribution from './PowerDistribution';
import SmartGeneration from './SmartGeneration';
import SmartProduct from './SmartProduct';

const CALandingPage: React.FC = () => {
    if (typeof window !== 'undefined') {
        if (!window.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        window.aniController = new ScrollMagic.Controller();
    }
    const { t } = useLang('wholehome');

    useEffect(() => {
        return () => {
            setTimeout(() => {
                /* @ts-ignore */
                if (aniController) aniController.destroy();
            });
        };
    }, []);

    const [isClient, setIsClient] = useState(false);
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);

    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        } else if (type === 'open') {
            setOpenQuoteFlag(true);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);
    return (
        <div className={styles.CALandingPage}>
            <A />
            <AMZMemberDay />
            <ForBackup />
            <OnePicture />
            <SmartProduct />
            <Flexible />
            <F />
            <G1 />
            <Choose />
            <EcoflowUsers />
            <JoinCommunity />
            <EnergyStorage />
            <SmartGeneration />
            <PowerDistribution />
            <Explore />
            <EndorsedBy />
            {/* <Disclaimer /> */}
            {isClient && <QuoteWinFloat callback={quoteCallback} />}
            {isClient && openQuoteFlag && <QuoteWin callback={quoteCallback} />}
        </div>
    );
};

export default CALandingPage;
